import styled from "styled-components";

export const Container = styled.div`
    > section + section {
        margin-top: 4.5rem;
    }
`;
